class ParametrosPagamento {
    constructor(
        {
            id = null, 
            mes = null, 
            ano = null, 
            data_pagamento = null, 
            usuario_inclusao = null, 
            data_inclusao = null, 
            usuario_alteracao = null, 
            data_alteracao = null,          
        } = {}
    ) {
        this.id = id;
        this.mes = mes;
        this.ano = ano;
        this.data_pagamento = data_pagamento;
        this.usuario_inclusao = usuario_inclusao;
        this.data_inclusao = data_inclusao;
        this.usuario_alteracao = usuario_alteracao;
        this.data_alteracao = data_alteracao;
    }
}

export default ParametrosPagamento;